// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"X3-z","displaySixCardTiles":"Y3-z"};